<script setup lang="ts">
  import { IconStakeholder } from '@gat-ship/icons'
  import type { StakeholderType } from '@gat-ship/types'

  defineProps<{
    stakeholderType: StakeholderType
    name: string
  }>()
</script>
<template>
  <div class="flex items-center gap-2 overflow-hidden">
    <IconStakeholder
      class="size-4 shrink-0"
      :stakeholder-type="stakeholderType"
    />
    <div class="truncate">{{ name }}</div>
  </div>
</template>
